import React from 'react';
import FeatureCta from './FeatureCta';
import Buttons from '../Buttons';
import './featureContent.css';

/* Smart link that routes to the correct app store */
const APP_DOWNLOAD_LINK = 'https://onelink.to/mvfvz4';

/**
 * Standard final CTA for feature pages: the shared FeatureCta (title, description,
 * primary "Start Free" button linking to the app download) plus the App Store /
 * Google Play buttons. The whole block is wrapped in an anchor target so the hero
 * "Start Free" button can scroll to it.
 *
 * @param {string} title - CTA heading
 * @param {string} description - CTA supporting text
 * @param {string} ctaLabel - primary button label
 * @param {string} storesLabel - label above the store buttons
 * @param {string} note - optional small note rendered under the primary CTA button
 * @param {string} anchorId - id applied to the wrapper (scroll target)
 * @param {string} className - extra class(es) applied to the wrapper
 */
function FeatureDownloadCta({ title, description, ctaLabel, storesLabel, note, anchorId = 'feature-download', className = '' }) {
    return (
        <div id={anchorId} className={className}>
            <FeatureCta
                title={title}
                description={description}
                ctaHref={APP_DOWNLOAD_LINK}
                ctaLabel={ctaLabel}
            >
                {note && <p className="fc-cta-note">{note}</p>}
                <div className="fc-cta-stores">
                    <p className="fc-cta-stores-label">{storesLabel}</p>
                    <Buttons />
                </div>
            </FeatureCta>
        </div>
    );
}

export default FeatureDownloadCta;
